import axios from 'axios'
import axiosConfig from './modules/axiosConfig'
import PageHome from './pages/Home.js'
import PageFundacaoMariaLuisa from './pages/Fundacao_Maria_Luisa'
import PageAgendaCultural from "./pages/Agenda_Cultural"
import PageSalaoDeCha from './pages/Salao_De_Cha'
import PageExposicoesTemporariasSingle from './pages/Exposicoes_Temporarias_Single'
import PageDsSections from './pages/ds_sections.js'
import PageLogin from './pages/Login'
import PageAtividadesEducativas from './pages/Atividades_Educativas'
import PageAconteceuSingle from './pages/Aconteceu_Single'
import PageAdministrativo from './pages/Administrativo'
import PageAgendamentoEvento from './pages/Agendamento_Evento'
import PageInstitucional from './pages/Institucional'
import PageAconteceu from './pages/Aconteceu'
import PageConcertosSingle from './pages/Concertos_Single'
import UseMouseOrKeyboard from './modules/UseMouseOrKeyboard'
import DesignSystem from './DesignSystem/DesignSystem'
import { register } from 'swiper/element/bundle'
import logs from './utils/logs'
import ripple from './modules/ripple'
import formErros from './modules/formErros'
import animaAoScroll from './animation/animaAoScroll'
import animateSetup from './animation/animateSetup'

import AccordionContent from './modules/accordionContent'
import textoAnuncio from './modules/textoAnuncio'
import ThumbYoutube from './modules/thumbYoutube'
import TelefoneAjuste from './modules/telefone'

import Menu from './modules/menu'
import Compartilhar from './modules/compartilhar'
import EditorJS from './modules/editorJs'
import GaleriaImagem from './modules/galeriaImagens'
import contatoForm from './modules/contato'
import DataAtual from './modules/dataAtual'
import Newsletter from './modules/newsletter'

// import SvgUse from "./utils/SvgUse";

// Init
GLOBAL.DesignSystem = DesignSystem({})
register() // Swiper Web Component

// Config
axiosConfig({ csrf: GLOBAL.context?.csrf }, axios)
UseMouseOrKeyboard()
ripple()
formErros()
animateSetup()
animaAoScroll()
AccordionContent()
textoAnuncio()
Menu()
GaleriaImagem()
ThumbYoutube()
TelefoneAjuste()
EditorJS()
DataAtual()
Newsletter()
//CheckContato()
Compartilhar()



// Pages
PageHome()
PageAtividadesEducativas()
PageDsSections()
PageExposicoesTemporariasSingle()
PageFundacaoMariaLuisa()
PageSalaoDeCha()
PageAconteceuSingle()
PageAdministrativo()
PageAgendamentoEvento()
PageInstitucional()
PageAconteceu()
PageLogin()?.init()
PageConcertosSingle()


contatoForm();

// utils logs
logs()
